// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"style_Dashboard__25c_3","MiddleRow":"style_MiddleRow__37RWh","TitleRow":"style_TitleRow__1rDmU","SettingsRow":"style_SettingsRow__UE4qx"};